module.exports = __webpack_public_path__ + "static/media/Helvetica-Bold.d13db1fe.ttf";